import { render, staticRenderFns } from "./PrettyRule.vue?vue&type=template&id=cf8e4c54"
import script from "./PrettyRule.vue?vue&type=script&lang=js"
export * from "./PrettyRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports